<template>
  <q-banner v-if="!confirmed" :class="`q-mt-xs q-pl-sm q-pr-md q-pb-md bg-${bgColor}`">
    <q-icon class="q-mr-xs" :color="iconColor" :name="icon" size="20px" />
    <span class="message">The provided VIN may be incorrect. Please double check your entry.</span>
    <slot />
    <div v-if="showCharacterDiff" class="character-diff q-my-sm">
      <div class="q-ml-xs q-mr-sm full-width">
        <div class="row justify-between items-center">
          <q-card bordered class="full-width q-mr-sm q-py-xs q-px-sm text-grey-8" flat>
            <span
              v-for="character in characterErrors"
              class="original-vin-char"
              :class="{ [`bg-${diffHighlightColor} text-white`]: character.error, removed: !character.value }"
              >{{ character.value || '&nbsp;'
              }}<ToolTip v-if="character.error"
                ><div class="char-tooltip">{{ character.error }}</div></ToolTip
              ></span
            >
          </q-card>
        </div>
        <div class="q-pl-xs text-caption text-italic text-grey-7">
          {{ diffType }} are highlighted in
          <span :class="`original-vin-char bg-${diffHighlightColor} text-grey-2`">{{ diffHighlightColorLabel }}</span>
        </div>
      </div>
    </div>
    <div v-if="!mustBeValid" class="row justify-start q-mt-sm q-ml-lg">
      <div>
        <PrimaryInlineButton class="text-no-wrap" @click="$emit('confirm')">{{ buttonText }}</PrimaryInlineButton>
      </div>
    </div>
  </q-banner>
  <q-banner v-else class="q-mt-xs q-pa-sm bg-green-1 text-green-10" dense>
    <div class="row items-center">
      <q-icon class="q-mr-xs" color="positive" name="check_circle" size="xs" />
      {{ confirmedText }}
    </div>
  </q-banner>
</template>

<script setup lang="ts">
import ToolTip from 'components/ToolTip.vue';

defineProps<{
  bgColor: string;
  buttonText: string;
  characterErrors: { value: string; error: string }[];
  confirmed: boolean;
  confirmedText: string;
  diffHighlightColor: string;
  diffHighlightColorLabel: string;
  diffType: string;
  icon: string;
  iconColor: string;
  mustBeValid?: boolean;
  showCharacterDiff: boolean;
}>();

defineEmits(['confirm']);
</script>

<style scoped lang="scss">
.message {
  position: relative;
  top: 2px;
}

.character-diff {
  margin-left: 22px;
}

.original-vin-char {
  display: inline-block;
  margin: 0 1px;

  &.removed {
    width: 8px;
  }
}

.char-tooltip {
  font-size: 12px;
}

.caption {
  line-height: 1.2;
}

.button {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  width: 100%;
}
</style>
